import { render, staticRenderFns } from "./signup-delivery-boy.vue?vue&type=template&id=58d22a3f&"
import script from "./signup-delivery-boy.vue?vue&type=script&lang=js&"
export * from "./signup-delivery-boy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports